module.exports = __webpack_public_path__ + "static/media/Admin-Portal.103cf4a8.svg";